import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  createSupplierButton: {
    marginTop: "24px",
    "& span": {
      whiteSpace: "nowrap",
    },
  },
  skeleton: {
    marginTop: "18px",
  },
  subtitle: {
    font: "normal 700 16px/24px Manrope",
    color: "#465869",
  },
  totalQuantityTitle: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#465869",
  },
  totalQuantityValue: {
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: "30px",
    lineHeight: "24px",
    color: "#465869",
  },
  marginLeft: {
    marginTop: 12,
    marginLeft: "auto",
  },
  supplierDetails: {
    padding: "12px 24px",
    "& h2": {
      font: "normal 700 16px/24px Manrope",
      color: "#465869",
    },
    "& h3": {
      font: "normal 600 14px/24px Manrope",
      color: "#308CDB",
    },
    "& span": {
      font: "normal 500 14px/24px Manrope",
      color: "#465869",
    },
  },
  line: {
    border: "1px solid #E4E7EC",
    height: "1px",
  },
}));

export default styles;
